import { LinkWrapper } from "components/Link/LinkWrapper";
import { ProjectTaskMeta } from "components/Task/ProjectTaskMeta";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import { Typography } from "@mui/material";
import { FilterSortTableDashboard } from "components/FilterSortTable/FilterSortTableDashboard";

const allowedFilters = [
  { key: "projectCode", value: "Project Code" },
  { key: "projectName", value: "Project Name" },
  { key: "bdc", value: "BDC" },
  { key: "projectDeadline", value: "Project Deadline" },
  { key: "recentComingDeadline", value: "Recent Comping Deadline" },
  { key: "isCritical", value: "Critical Items" },
  { key: "minDeadline", value: "Min Deadline" },
  { key: "maxDeadline", value: "Max Deadline" },
];

export const projectTaskListColumnsL = ({
  handleTaskClick,
  records,
  setOutputRecords,
}) => [
  {
    field: "statusCritical",
    headerName: "Project",
    flex: 1,
    renderHeader: (params) => (
      <FlexBox justifyContent="space-between" alignItems="center">
        <FilterSortTableDashboard
          records={records}
          setOutputRecords={setOutputRecords}
          allowedFilters={allowedFilters}
        />
        <Typography>Projects</Typography>
      </FlexBox>
    ),
    renderCell: (params) => (
      <LinkWrapper onClick={() => handleTaskClick(params.row.projectId)}>
        <ProjectTaskMeta row={params.row} />
      </LinkWrapper>
    ),
    sortable: false,
  },
];
